<div
  #playerRoot
  class="mp3-player-root"
  tabindex="0"
  [hidden]="!url"
>
  <div class="mp3-controls">
    <app-mp3-volume
      #volume
      [audio]="audio"
      [currentSoundEffect]="currentSoundEffect"
      [darkColor]="useForLightshowEditor"
    >
    </app-mp3-volume>
    <button
      [isDisabled]="disableHoverTips || !useForLightshowEditor"
      tooltip='Playback Button. Clicking this will begin the light show preview. In "Torch" mode, press the Space Bar during playback to create a new torch segmen'
      placement="left"
      (click)="isPlaying ? pause() : play()"
      type="button"
      container="body"
      class="mp3-control-button"
      [ngClass]="{ 'control-button-torch-hover': editorMode === 'TORCH', 'vertical-offset': !useForLightshowEditor}"
    >

      <svg
        viewBox="0 0 36 36"
        style="height: 100%; width: 100%;"
        *ngIf="isPlaying"
      >
        <defs>
          <path
            id="pause-icon"
            data-state="playing"
            d="M11,10 L17,10 17,26 11,26 M20,10 L26,10 26,26 20,26"
          />
        </defs>
        <use [attr.xlink:href]="'#pause-icon'" />
      </svg>

      <svg
        viewBox="0 0 36 36"
        style="height: 100%; width: 100%;"
        *ngIf="!isPlaying && editorMode === 'SCREEN'"
      >
        <defs>

          <path
            id="play-icon"
            data-state="paused"
            d="M11,10 L18,13.74 18,22.28 11,26 M18,13.74 L26,18 26,18 18,22.28"
          />
        </defs>
        <use [attr.xlink:href]="'#play-icon'" />
      </svg>

      <div class="control-circle-icon" *ngIf="editorMode === 'TORCH' && !isPlaying"></div>

    </button>
  </div>
  <div class="slider-container">
    <div class="timestamp-container" [ngClass]="{'horizontal-offset': !useForLightshowEditor}">
      <span
        [ngClass]="{ 'push-to-right': volume.shouldPush }"
        [ngStyle]="{'color': useForLightshowEditor ? '#8D8E90' : '#ccc'}"
        >{{ formatSecondsToMinutes(playPosition) }}
      </span>
      <div>
        <span [ngStyle]="{'color': useForLightshowEditor ? '#8D8E90' : '#ccc'}" style="margin-right: 10px;">{{
          formatSecondsToMinutes(totalDuration)
        }}</span>
        <span [ngStyle]="{'color': useForLightshowEditor ? '#333' : '#ccc'}"
          >{{ totalDuration === 0 ? 0 : ((playPosition * 100) / totalDuration).toFixed(0) }}%
          Completed</span
        >
      </div>
    </div>
    <div #grooveContainer class="groove-container" [ngClass]="{'groove-overflow': zoomScale > 1}">
      <div dndDropzone (dndDrop)="onSegmentDrop($event)" #groove class="groove" tabindex="-1">
        <ngx-loading [show]="waveformLoading"></ngx-loading>

        <span
          #seekThumb
          class="seek-thumb-group"
          [style.left]="'calc(' + playbackDone + '% - '+ SEEK_THUMB_DRAGGABLE_HALF_AREA / zoomScale + 'px)' "
          [ngStyle]="{ transform: 'scaleX(' + 1 / zoomScale + ')', width: SEEK_THUMB_DRAGGABLE_HALF_AREA*2 + 'px'}"
        >
          <div class="seek-thumb-line"></div>
          <div class="seek-thumb-triangle"></div>
          <div class="seek-thumb-rectangle"></div>
        </span>
        <div>
          <!-- SCREEN EDITOR -->
          <div *ngIf="editorMode === 'SCREEN'" >
            <div 
              *ngFor="let seg of segmentsFormArray.controls;
                let i = index;
                trackBy: trackByIndex
              ">
              <div
                *ngIf="(segmentMode === segmentModeType.IMAGE && (seg.value.segmentType === 16 || seg.value.segmentType === 31)) ||
                      (segmentMode === segmentModeType.COLOR && (seg.value.segmentType === 5 || seg.value.segmentType === 6)) ||
                      (segmentMode === segmentModeType.SOUND && seg.value.audioUrl && seg.value.audioName) ||
                      (seg.value.segmentType === -1)"
                class="screen slider-body"
                [id]="i"
                [ngClass]="{ 'slider-smoother': isDraggingSliderBody }"
                [style.z-index]="seg === selectedSegment || isPlaying ? 0 : 1"
                [class.highlight]="seg === selectedSegment && !seg.value.frozen"
                [style.background]="seg.value.color"
                [style.width.%]="
                  (100 * seg.value.duration * timeFactorMs) / totalDuration
                "
                [style.left.%]="
                  (100 * seg.value.position * timeFactorMs) / totalDuration
                "
                [style.pointer-events]="seg.value.frozen ? 'none' : null"
                [ngStyle]="{'display': seg.value.hidden ? 'none' : 'block'}"
              >
                <div 
                  *ngIf="seg.value.enableSegmentGrips" 
                  class="screen grip grip-left"
                  [style.width.%] = "15/zoomScale"
                  [style.left.%] = "0"
                >
                </div>
                <div 
                  *ngIf="seg.value.enableSegmentGrips" 
                  class="screen grip grip-right"
                  [style.width.%] = "15/zoomScale"
                  [style.right.%] = "0"
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- SCREEN EDITOR -->

          <!-- TORCHE EDITOR -->
          <div *ngIf="editorMode === 'TORCH' && useForLightshowEditor">
            <div
              *ngFor="let torch of torchArray; let i = index"
              [id]="i"
              [ngClass]="{ 'slider-smoother': isDraggingSliderBody }"
              class="slider-body"
              [style.z-index]="
                checkIfOperationIsSelected(torch.uniqueId) || isPlaying ? 0 : 1
              "
              [class.highlight]="
                checkIfOperationIsSelected(torch.uniqueId) && !torch.frozen
              "
              [style.background]="torch.timelineColor"
              [style.width.%]="
                (100 * torch.duration * timeFactorMs) / totalDuration
              "
              [style.left.%]="
                (100 * torch.position * timeFactorMs) / totalDuration
              "
              [style.pointer-events]="torch.frozen ? 'none' : null"
              [hidden]="!torchArray[i].show"
            >
              <div
                class="grip grip-left"
                [style.width.%] = "20/zoomScale"
                [style.left.%] = "0"
              ></div>
              <div
                class="grip grip-right"
                [style.width.%] = "20/zoomScale"
                [style.right.%] = "0"
              ></div>
            </div>
          </div>
          <!-- TORCH EDITOR -->

          <div id="waveform"></div>

          <span
            [hidden]="!canCropEnd"
            style="height: 100%; background: dimgray; position: absolute; right: 0; z-index: 100; transform: translate(0px, -128px);"
            [style.width.%]="cropEndPercent"
          >
            <span
              #cropEndGrip
              class="crop-end-grip"
              [ngStyle]="{
                transform:
                  ' translate(-50%, -50%) scaleX(' + 1 / zoomScale + ')'
              }"
            ></span>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div
    [isDisabled]="disableHoverTips || !useForLightshowEditor"
    tooltip="While hovering your mouse over the Timeline, scroll your mouse wheel to zoom in and out"
    class="zoom-percentage center-items" *ngIf="useForLightshowEditor">
    <input
      class="zoom-input"
      (keyup.enter)="changeZoomScale($event)"
      (focusout)="changeZoomScale($event)"
      [ngModel]="zoomScaleDisplay"
      style="width: 100%;"
      type="number"
      (focus)="zoomFocus = true"
      (blur)="zoomFocus = false"
    />
     %
  </div>
  <div><audio #audio [attr.src]="url"></audio></div>
</div>
